export default "__VITE_ASSET__D0ref1MD__"